



























import { Component, Prop, Vue } from 'vue-property-decorator';

// TODO document2
import { Page } from '@/model/document2/page/page'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Rectangle } from '@/utilityModels/rectangle'

import * as def from '@/definitions'
import { UnitHelper } from '@/helper/unitHelper';

@Component({
    components: {
    }
})
export default class DesignBorder extends Vue 
{
    @Prop() private documentRotate! : number;
    @Prop() private isReverseSurface! : boolean
    @Prop() private page! : Page;
    @Prop() private designPosition! : number;
    @Prop() private borderColor! : ColorConstruct;
    @Prop({default: 2}) private borderWidth! : number; 
    @Prop() private isRendering! : boolean;
    @Prop({default: false}) private isDragGuideVisible! : boolean;

    private mm2px(mm : number)
    {
        return this.isRendering ? UnitHelper.convert(mm, "mm", "px", 72) : UnitHelper.convert(mm, "mm", "px");
    }

    private get borderWidthRender()
    {
        // Label9と合わせて1ptとする
        var mm = UnitHelper.convert(1, "pt", "mm");
        return mm;
    }

    // 破線で表示するか?
    private get isDashedStrokeVisible()
    {
        var result = false;
        if(this.$router.currentRoute.path == "/LayoutEditor" && this.$store.getters.applicationState.layoutCopyMode == 1)
        {
            // レイアウトでコピーモード中は破線
            result = true;
            if(this.page.currentDesignPosition == this.designPosition)
            {
                // カレントのとき実線
                result = false;
            }
            else
            {
                var page = this.$store.getters.document.pageList[this.$store.getters.applicationState.layoutCopyPage];
                if(page == this.page && this.designPosition == this.$store.getters.applicationState.layoutCopyPosition &&
                    this.isReverseSurface == this.$store.getters.applicationState.layoutCopyReverse)
                {
                    // コピー元のとき実線
                    result = false;
                }
            }
        }

        return result;
    }

    private getDesignRect()
    {
        return this.page.getSurface(this.isReverseSurface).getDesignRect(this.designPosition);
    }

    private get canvasX()
    {
        return this.mm2px(this.getDesignRect().x);
    }

    private get canvasY()
    {
        return this.mm2px(this.getDesignRect().y);
    }

    private get borderColorHex()
    {
        return this.borderColor.hex;
    }


    private get maskColorHex(){
        if (this.isRendering) { return "none"; }
        // return this.designPosition == this.page.currentDesignPosition ? this.shadeColor(this.borderColorHex, 80) : "none";
        return this.designPosition == this.page.currentDesignPosition ? this.borderColorHex : "none";
    }

    private get canvasWidth()
    {
        return this.mm2px(this.getDesignRect().width);
    }

    private get canvasHeight()
    {
        return this.mm2px(this.getDesignRect().height);
    }

    private get canvasRadiusX() : number
    {
        var radius = this.page.getSurface(this.isReverseSurface).getFrameRadius(this.page.currentDesignPosition);
        return this.mm2px(radius);
    }

    private get canvasRadiusY() : number
    {
        var radius = this.page.getSurface(this.isReverseSurface).getFrameRadius(this.page.currentDesignPosition);
        return this.mm2px(radius);
    }

    // 楕円として描画するか
    private get isEllipseFrame()
    {
        var radius = this.page.getSurface(this.isReverseSurface).getFrameRadius(this.page.currentDesignPosition);
        var rect = this.page.getSurface(this.isReverseSurface).getDesignRect(this.page.currentDesignPosition);

        return rect.width <= radius * 2 || rect.height <= radius * 2;
    }

    private get isInnerCircleVisible()
    {
        return this.page.getSurface(this.isReverseSurface).getFrameInnerCircleRadius(this.page.currentDesignPosition) > 0;
    }

    private get canvasInnerCX()
    {
        return this.canvasX + this.canvasWidth / 2;
    }

    private get canvasInnerCY()
    {
        return this.canvasY + this.canvasHeight / 2;
    }

    private get canvasInnerR()
    {
        var innerR = this.page.getSurface(this.isReverseSurface).getFrameInnerCircleRadius(this.page.currentDesignPosition);
        return this.mm2px(innerR);
    }

    shadeColor(color, percent) {
        var num = parseInt(color.slice(1),16), amt = Math.round(2.55 * percent), R = (num >> 16) + amt, G = (num >> 8 & 0x00FF) + amt, B = (num & 0x0000FF) + amt;
        return "#" + (0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (G<255?G<1?0:G:255)*0x100 + (B<255?B<1?0:B:255)).toString(16).slice(1);
    }
    
}

